import React from 'react';

import { Button as RebassButton } from 'rebass';

// import PropTypes from 'prop-types';
import styled from 'styled-components';

const Button = styled(({ transparent, ...props }) => <RebassButton color="gray2" bg="transparent" {...props} />)`
  border: 1px solid #bdd0db;
  display: block;
  font-weight: normal;
  ${({ transparent }) => !transparent && 'background-color: white;'}
  cursor: pointer;
  font-size: 14px;
  color: #637e99;
  padding: 12px 15px 12px 15px;

  &:hover, &:focus {
    border-color: #537eaa;
    background-color: #537eaa;
    color: white;
  }
`;

Button.propTypes = {
};

Button.defaultProps = {
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Atoms/Button/index.js